import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { COMMUNITY_UPDATE_PAGE_ROUTE } from "../../_pages/community-settings/community-general-settings.page";
import { USER_PROFILE_UPDATE_PAGE_ROUTE } from "../../_pages/community-settings/profile-update.page";
import IconButton2 from "../icon-button-2-component";

function CommunitySettingIcon({ community }) {
  return (
    <>
      {community ? (
        <Link
          to={
            community.myRole === "admin"
              ? COMMUNITY_UPDATE_PAGE_ROUTE
              : USER_PROFILE_UPDATE_PAGE_ROUTE
          }>
          <IconButton2 icon="settings" className="theme-text-default" />
        </Link>
      ) : (
        <></>
      )}
    </>
  );
}

const stp = (state) => ({
  community: state.community,
});

export default connect(stp)(CommunitySettingIcon);
